import endpoints from './endpoints';

export default endpoints;
